import { mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-detail-graph-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "pantry-detail-graph-view-grapharea",
      style: _ctx.styleCanvasArea
    }, [
      _createVNode("canvas", _mergeProps({ class: "pantry-detail-graph-view-grapharea-canvas" }, _ctx.drawScreen, {
        ref: "canvas",
        width: _ctx.canvasSize.width,
        height: _ctx.canvasSize.height
      }), null, 16, ["width", "height"])
    ], 4)
  ]))
}